import React from "react";
import { StripeRequirementError } from "@/services/interfaces/IBillingSettingsService";
import { useTranslation } from "react-i18next";

export function StripeProblems({
  disabledReason,
  requirementErrors,
}: {
  disabledReason?: string | null;
  requirementErrors?: StripeRequirementError[] | null;
}) {
  const hasDisabled = Boolean(disabledReason);
  const hasErrors = Boolean(requirementErrors?.length);
  const { t } = useTranslation();

  if (!hasDisabled && !hasErrors) return null;

  return (
    <div className="border-custom-destructive-dark/40 bg-custom-destructive-dark/5 text-custom-destructive-dark flex flex-col gap-2 rounded-lg border p-4 text-sm">
      {hasDisabled && (
        <div>
          {t("billing.disabledReason")}: {disabledReason}
        </div>
      )}

      {hasErrors && (
        <div className="flex flex-col gap-1">
          {requirementErrors?.map((error) => (
            <div key={error.requirement}>
              {error.requirement}: {error.reason}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
